import { createApi } from "@reduxjs/toolkit/query/react";
import { DynamicBaseQuery } from "./baseQuery";
import { GetFormsRequest } from "./types/forms/requests/GetFormsRequest";
import { AssessmentFormsIndexResponse } from "./types/forms/responses/AssessmentFormsIndexResponse";
import { SingleFormResponse } from "./types/forms/responses/SingleFormResponse";
import { AssessmentEditRequest } from "./types/assessments/requests/AssessmentEditRequest";
import { invalidateFormsOnSuccess } from "../../features/assessments/utils/rtkQueryUtils";

export const adminAssessmentsApi = createApi({
  reducerPath: "adminAssessmentsApi",
  baseQuery: DynamicBaseQuery,
  tagTypes: ["Form"],
  endpoints: (builder) => ({
    getAdminAssessmentIndex: builder.query<
      AssessmentFormsIndexResponse,
      GetFormsRequest
    >({
      query: (params?) => ({
        url: "/forms",
        method: "GET",
        params: {
          ...params,
          sort: ["-created_at"],
        },
      }),
      providesTags: (result) => {
        return result?.map((item) => ({ type: "Form", id: item.id })) ?? [];
      },
    }),
    getAdminAssessment: builder.query<SingleFormResponse, { id: number }>({
      query: (params) => ({
        url: `/forms/${params.id}`,
        method: "GET",
      }),
    }),
    deleteAdminAssessment: builder.mutation<void, { id: number }>({
      query: (params) => ({
        url: `/forms/${params.id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Form"],
      onQueryStarted: invalidateFormsOnSuccess,
    }),
    createAdminAssessment: builder.mutation<
      void,
      { form: AssessmentEditRequest }
    >({
      query: (params) => ({
        url: `/forms`,
        method: "POST",
        body: params.form,
      }),
      invalidatesTags: ["Form"],
      onQueryStarted: invalidateFormsOnSuccess,
    }),
    updateAdminAssessment: builder.mutation<
      void,
      { id: number; form: AssessmentEditRequest }
    >({
      query: (params) => ({
        url: `/forms/${params.id}`,
        method: "PUT",
        body: params.form,
      }),
      invalidatesTags: ["Form"],
      onQueryStarted: invalidateFormsOnSuccess,
    }),
  }),
});
export const {
  useGetAdminAssessmentIndexQuery,
  useGetAdminAssessmentQuery,
  useUpdateAdminAssessmentMutation,
  useCreateAdminAssessmentMutation,
  useDeleteAdminAssessmentMutation,
} = adminAssessmentsApi;
